module.exports = __webpack_public_path__ + "img/db_helvethaicaais_x_med_v3.2-webfont.50d0ce10.svg";